var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutPopoverIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.425,
    height: 17.553,
    viewBox: "0 0 15.425 17.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-3720912",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M158.275,126.983a.357.357,0,0,0,.183-.315v-2a.365.365,0,0,0-.161-.3.371.371,0,0,0-.344-.037,7.714,7.714,0,1,0,5.833,0,.367.367,0,0,0-.5.34v2a.367.367,0,0,0,.183.318,5.18,5.18,0,1,1-5.189,0Z",
    transform: "translate(-153.159 -121.625)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M310.427,63.347V57.678a1.68,1.68,0,1,0-3.361,0v5.668a1.68,1.68,0,1,0,3.361,0Z",
    transform: "translate(-301.036 -55.996)",
    fill: "#ddd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutPopoverIcon);
export default __webpack_public_path__ + "static/media/logout_popover_icon.d80bfca0a74de7d8652aef89ae2a68af.svg";
export { ForwardRef as ReactComponent };